import { getConfig } from "../config";

export const smoothScroll = (anchor: string) => {
  const element = document.getElementById(anchor);
  if (!element) return;

  const padding = 100;
  // Use the absolute document position rather than `offsetTop`: an ancestor with a CSS
  // transform (e.g. AnimatedView) becomes the element's offsetParent, which would make
  // `offsetTop` relative to it and scroll to the top of the page instead of the section.
  const position = element.getBoundingClientRect().top + window.scrollY;

  window.scrollTo({
    top: position - padding,
    behavior: "smooth"
  });
};

export const generateId = (length: number) => {
  let result = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
};

export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const getImagePath = (imageName?: string) => {
  const basePath = getConfig().API_BASE_PATH;
  return imageName ? `${basePath}/stock/image/${imageName}` : undefined;
};

export const getDocumentPath = (documentName?: string) => {
  const basePath = getConfig().API_BASE_PATH;
  return documentName ? `${basePath}/stock/file/${documentName}` : undefined;
};

export const formatPrice = (price: number) => {
  return price.toLocaleString("sk", {
    style: "currency",
    currency: "EUR"
  });
};

export const formatStock = (amount: number, precision = 2) => {
  const formatted = amount.toLocaleString("sk", {
    style: "decimal",
    maximumFractionDigits: precision
  });

  return formatted;
};

export const roundNumber = (price: number, decimals = 2) => {
  return parseFloat(price.toFixed(decimals));
};

export const getPriceWithTax = (price: number, tax: number) => {
  const taxMultiplier = tax && tax > 0 ? 1 + tax / 100 : 1;

  // Round the final amount so currency values stay at 2 decimal places and
  // sums of components match the displayed total cent-for-cent.
  return roundNumber(price * taxMultiplier);
};

export const getPageTitle = (title?: string): string =>
  title ? `Ecocerram - ${title}` : "Ecocerram - Tiles by Goodway";

export const replaceParam = (text: string, param: string, value: string) => {
  return text.replaceAll(`{{${param}}}`, value);
};

export const route = (
  path: string,
  query?: Record<string, string | number | boolean | undefined | null>,
  params?: Record<string, string | number | boolean | undefined | null>
) => {
  let urlPath: string = path;
  if (query) {
    // Remove undefined values from the query object
    Object.keys(query).forEach(
      (key) => (query[key] === undefined || query[key] === null) && delete query[key]
    );

    const searchParams = new URLSearchParams(query as Record<string, string>);
    urlPath = `${path}?${searchParams.toString()}`;
  }

  if (params) {
    for (const [key, value] of Object.entries(params)) {
      if (value) {
        urlPath = urlPath.replaceAll(`:${key}`, encodeURIComponent(value));
      }
    }
  }

  return urlPath;
};
